import { Autocomplete, Button, Input } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useState } from "react";
import { RootState } from "src/context/store";
import { useDispatch, useSelector } from "react-redux";
import { getOrderDetailsByOrderCode, updateOrderStatus } from "src/services/order-api";
import { ordActions } from "src/context/order-slice";
import { useEventStatus } from "src/hooks/useEventStatus";
import { Loader2 } from "lucide-react";

export const MAIN_ORDER_STATUS_ID = [
  { key: 7, name: "Order Rejected" },
  { key: 0, name: "Order Completed" },
  { key: 1, name: "Order Cancelled" },
];

const ChangeOrderStatus = ({ onCloseModal }: { onCloseModal: () => void }) => {
  const [reason, setReason] = useState<string>("");
  const [selectedOrderStatus, setSelectedOrderStatus] = useState<any>(null);
  const { orderDetailsFiltered } = useSelector((state: RootState) => state.ord);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { withEventCheck } = useEventStatus();
  const { toast } = useToast();

  const handleSaveChanges = async () => {
    setIsLoading(true);
    const payload = {
      data: {
        order_id: orderDetailsFiltered?.[0]?.order_id_int,
        order_status_id: selectedOrderStatus?.key,
        reason: reason,
      },
      primary_key: orderDetailsFiltered?.[0]?.order_id_int,
      event_type: "UPDATE_ORDER_STATUS",
    };
    try {
      const response = await updateOrderStatus(payload);
      const response2 = await withEventCheck(
        () => {
          return getOrderDetailsByOrderCode(orderDetailsFiltered?.[0]?.order_code);
        },
        response?.data?.data?.eventStreamCreated?.streamId
      );
      dispatch(ordActions.setOrderDetailsFiltered([response2?.data?.data]));
      toast({ description: "Order status updated successfully", variant: "default" });
      onCloseModal();
      setIsLoading(false);
    } catch (error: any) {
      toast({ description: error?.response?.data?.message, variant: "destructive" });
      onCloseModal();
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-y-2 mb-4 w-[340px] mx-auto px-6 bg-white p-4 rounded-xl">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#49484C]">Change Order Status</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      <div className="">
        <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">
          Are you sure you want to change this order’s discount method? This can be re-adjusted on the Order page.
        </p>
        <Autocomplete
          inputClassName=""
          placeholder="Select Order Status"
          suggestionList={MAIN_ORDER_STATUS_ID}
          displayKey="name"
          uniqueKey="key"
          onSelectionChange={(e: any) => setSelectedOrderStatus(e)}
        />
        {/* <p className="text-sm text-[#616161]">Invoice No</p> */}

        <p className="text-sm mb-2 mt-6 font-normal text-[#666666]">Write a reason...</p>
        <Input
          type="text"
          placeholder="Enter Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="w-full border py-4 border-[#D0D0D0] rounded-md p-2 h-8"
        />
      </div>

      <Button disabled={isLoading} className="text-white bg-[#8051FF] mt-2" onClick={handleSaveChanges}>
        {isLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save Changes"}
      </Button>
    </div>
  );
};

export default ChangeOrderStatus;
